/**
 * This file is automatically generated using generator/actions/generate-action.ts.
 * Do NOT modify this file by hand.
 */

import { AxiosInstance, AxiosRequestConfig } from 'axios';
import { SweetPath } from 'sweet-path';

import { CancelFamilyMemberTemporaryPinCodePathParameters } from 'api/actions/cancel-family-member-temporary-pin-code/cancel-family-member-temporary-pin-code-path-parameters';
import { CancelFamilyMemberTemporaryPinCodeResponse } from 'api/actions/cancel-family-member-temporary-pin-code/cancel-family-member-temporary-pin-code-response';

type CancelFamilyMemberTemporaryPinCodeQueryParameters = Record<string, any>;

/**
 * The path of the CancelFamilyMemberTemporaryPinCode action.
 */
export const cancelFamilyMemberTemporaryPinCodeActionPath = new SweetPath<
  keyof CancelFamilyMemberTemporaryPinCodePathParameters
>('/user/family/members/{userId}/pin/temporary/{temporaryPinCodeId}/cancel', { path: '{param}' });

/**
 * Creates a contextualized CancelFamilyMemberTemporaryPinCode actions.
 */
export default function createCancelFamilyMemberTemporaryPinCodeAction(axios: AxiosInstance) {
  return function cancelFamilyMemberTemporaryPinCodeAction({
    headers = {},
    parameters,
    query = {},
  }: {
    headers?: AxiosRequestConfig<any>['headers'];
    parameters: CancelFamilyMemberTemporaryPinCodePathParameters;
    query?: CancelFamilyMemberTemporaryPinCodeQueryParameters;
  }) {
    const path = cancelFamilyMemberTemporaryPinCodeActionPath.insert(parameters);

    return axios.post<CancelFamilyMemberTemporaryPinCodeResponse, CancelFamilyMemberTemporaryPinCodeResponse>(path, {
      params: query,
      headers,
    });
  };
}
